module.exports = __webpack_public_path__ + "static/badge-money-back-300-x-300-6704641d57d5b24c3567f3b724695f03.svg";